<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['options','height','data'],
  methods: {
    newData: function() {
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            data: this.ni,
            fill: true,
            backgroundColor: "rgba(111,255,133, 0.5)", // <-- supposed to be light blue
            // borderColor: "#41c6ff",
            label: "N-I"
          },
          {
            data: this.id,
            fill: true,
            backgroundColor: "rgba(255,152,111, 0.5)",
            // borderColor: "#ffb041",
            label: "I/D"
          },
        ]},
        {
          legend: {
            position: 'top'
          },
          title: {
            display: true,
            fontSize: 20,
            text: 'FSS: Activité journalière'
          },
          // responsive: false,
          // Can't just just `stacked: true` like the docs say
          scales: {
            // xAxes: [{ stacked: true }],
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Nombre d\'usagers uniques'
              },
              // stacked: true,
            }]
          },
          animation: {
            duration: 750,
          },
        }
      )
    }
  },
  computed: {
    labels: function() {
      let result = [];
      for(var value of this.data) {
        result.push(value.date.substring(5, 10));
      }
      return result;
    },
    // datasets
    id: function() {
      let result = [];
      for(var value of this.data) {
        result.push(value.distinctActiveUsersID);
      }
      return result;
    },
    ni: function() {
      let result = [];
      for(var value of this.data) {
        result.push(value.distinctActiveUsersNI);
      }
      return result;
    },
  },
  watch: {
    data: function() {
      this.newData();
    }
  },
  mounted() {
    this.newData();
    // this.renderChart(this.chartdata, this.options)
    // this.renderChart({data: [10,14,15]}, this.options)
  }
}
</script>
